import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-16 py-5"
}
const _hoisted_2 = { class: "mt-2 mb-2 flex justify-center" }
const _hoisted_3 = { class: "w-8" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, "Fetching prompts...", -1)
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "flex justify-end mb-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingIcon = _resolveComponent("LoadingIcon")!
  const _component_RefreshIcon = _resolveComponent("RefreshIcon")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_ctx.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_LoadingIcon)
          ])
        ]),
        _hoisted_4
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
        (_ctx.trizPrompts.length > 0)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.trizPrompts, (prompt, promptIndex) => {
              return (_openBlock(), _createElementBlock("p", {
                key: promptIndex,
                class: "text-base px-4 py-3 mt-3 bg-cebai-grey-lighter rounded-lg"
              }, _toDisplayString(prompt.text), 1))
            }), 128))
          : (_openBlock(), _createElementBlock("p", _hoisted_6, " Sorry, we were unable to generate any prompts from your idea. Try adding more detail to your idea and press refresh. ")),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_AppButton, {
            type: "text",
            onClick: _withModifiers(_ctx.fetchPrompts, ["prevent"])
          }, {
            iconBefore: _withCtx(() => [
              _createVNode(_component_RefreshIcon, { class: "mr-2 fill-current" })
            ]),
            default: _withCtx(() => [
              _createTextVNode(" Refresh ")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]))
}